/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './EmprestimoGarantiaCarroPorQue.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import WhiteButton from '@/components/atoms/WhiteButton';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';

function EmprestimoGarantiaCarroPorQue() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="emp-garantia-carro-por-que">
        <div className="emp-garantia-carro-por-que-p1">
          <ContainerHome24>
            <img
              src="assets/emprestimo-garantia-carro/img-por-que.svg"
              alt="ilustração"
              width="240"
              height="230"
            />
            <div className="por-que-textos">
              <h3 className="por-que-titulo">
                Por que usar o Empréstimo com Garantia de Veículo no Santander?
              </h3>
              <p className="por-que-subtitulo">
                Com o <b>Crédito Pessoal com Garantia de Veículo</b>, você tem a liberdade de usar o
                dinheiro como quiser, seja para realizar seus sonhos ou enfrentar imprevistos!
              </p>
            </div>
          </ContainerHome24>
        </div>
        <div className="emp-garantia-carro-por-que-p2">
          <ContainerHome24>
            <div>
              <CustomEmblaCarouselHome24
                // loop
                enableBullets
                detectBulletCount
                hideOverflow
                enableMobileArrows
                enablePrevArrow
                //autoplay={100000}
              >
                {({ className }) => (
                  <>
                    <div className={`slide ${className}`}>
                      <img
                        src="assets/emprestimo-garantia-carro/por-que-slide/ic_hands.svg"
                        alt=""
                        width="49"
                        height="49"
                      />
                      <p className="slide-texo">
                        Taxas a partir
                        <br /> de 1,39% a.m.
                      </p>
                    </div>
                    <div className={`slide ${className}`}>
                      <img
                        src="assets/emprestimo-garantia-carro/por-que-slide/ic_leptop.svg"
                        alt=""
                        width="49"
                        height="49"
                      />
                      <p className="slide-texo">
                        Simulação online e<br /> em até 2 minutos
                      </p>
                    </div>
                    <div className={`slide ${className}`}>
                      <img
                        src="assets/emprestimo-garantia-carro/por-que-slide/ic_schedule_spending.svg"
                        alt=""
                        width="49"
                        height="48"
                      />
                      <p className="slide-texo">
                        Limite de até
                        <br /> R$ 200 mil
                      </p>
                    </div>
                    <div className={`slide ${className}`}>
                      <img
                        src="assets/emprestimo-garantia-carro/por-que-slide/ic-card.svg"
                        alt=""
                        width="49"
                        height="48"
                      />
                      <p className="slide-texo">
                        Pagamento em
                        <br /> até 60x
                      </p>
                    </div>
                    <div className={`slide ${className}`}>
                      <img
                        src="assets/emprestimo-garantia-carro/por-que-slide/ic_business_store.svg"
                        alt=""
                        width="49"
                        height="48"
                      />
                      <p className="slide-texo">
                        1º parcela em
                        <br />
                        até 30 dias
                      </p>
                    </div>
                  </>
                )}
              </CustomEmblaCarouselHome24>
            </div>
            <WhiteButton
              href="https://emprestimosim.com.br/app/#/onboarding/signUp"
              target="_blank"
              className="btn-por-que-simular"
            >
              Simular
            </WhiteButton>
          </ContainerHome24>
        </div>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default EmprestimoGarantiaCarroPorQue;
